import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa"; // Importing icons
import { Link } from "react-router-dom";
import "../assets/style.css";

const TableTwo = () => {
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 box-margin height-card">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h5>Customer List</h5>
                <Link to="/Customer/Form_two">
                  <button className="btn btn-primary" style={{ backgroundColor: '#072848', color: 'white' }}>Add</button>
                </Link>
                {/* <button className="btn btn-primary" style={{ backgroundColor: '#072848', color: 'white' }}>Add</button> */}
              </div>
            </div>
          </div>

          <div className="col-xl-12 mb-4">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  style={{ maxWidth: "600px" }}
                />
                <div>
                  <button className="btn btn-primary btn-sm me-2" style={{ backgroundColor: '#072848', color: 'white' }}>Search</button>
                  <button className="btn btn-secondary btn-sm">Reset</button>
                </div>
              </div>
              <div className="card-body table-border-style">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead className="table-dark">
                      <tr>
                        <th className="text-white">#</th>
                        <th className="text-white">First Name</th>
                        <th className="text-white">Last Name</th>
                        <th className="text-white">Email</th>
                        <th className="text-white">Phone</th>
                        <th className="text-white text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>Mark</td>
                        <td>Otto</td>
                        <td>mark.otto@example.com</td>
                        <td>123-456-7890</td>
                        <td className="text-center">
                          <FaEdit className="text-warning me-2" style={{ cursor: "pointer" }} />
                          <FaTrash className="text-danger" style={{ cursor: "pointer" }} />
                        </td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Jacob</td>
                        <td>Thornton</td>
                        <td>jacob.thornton@example.com</td>
                        <td>123-456-7891</td>
                        <td className="text-center">
                          <FaEdit className="text-warning me-2" style={{ cursor: "pointer" }} />
                          <FaTrash className="text-danger" style={{ cursor: "pointer" }} />
                        </td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>Larry</td>
                        <td>Bird</td>
                        <td>larry.bird@example.com</td>
                        <td>123-456-7892</td>
                        <td className="text-center">
                          <FaEdit className="text-warning me-2" style={{ cursor: "pointer" }} />
                          <FaTrash className="text-danger" style={{ cursor: "pointer" }} />
                        </td>
                      </tr>
                      {/* Add more rows as needed */}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TableTwo;
